var React = require('react');

function AvatarBlue (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M59.61,79.69H0V55.19A24.47,24.47,0,0,1,13.92,33,20.49,20.49,0,0,1,16.37,5.14,20.2,20.2,0,0,1,32.1.13,20.43,20.43,0,0,1,45.7,33,24.46,24.46,0,0,1,59.61,55.19ZM6.29,73.4h47V55.19A18.39,18.39,0,0,0,39.46,37.46a3.31,3.31,0,0,1-1.23-5.84A14.13,14.13,0,0,0,31.4,6.38,13.81,13.81,0,0,0,20.56,9.83a14.2,14.2,0,0,0,.81,21.78,3.31,3.31,0,0,1-1.24,5.85A18.18,18.18,0,0,0,6.29,55.19ZM42.07,36.61h0Zm-24.54,0h0Zm22.61-2.48h0Zm-21.5-2.76h0Z","fill":"#2a2d58","key":1})]);
}

AvatarBlue.defaultProps = {"viewBox":"0 0 59.61 79.69"};

module.exports = AvatarBlue;

AvatarBlue.default = AvatarBlue;
